<template>
  <div id="popUpWin">
    <div>
      <div class="cross" v-on:click="closePopUp">
        <cross-icon/>
      </div>
      <h1>Реквизиты счета</h1>

      <div class="reqLines">
        <div class="reqLine">
          <p>Наименование платежа</p>
          <p>Л/C XXXXXX</p>
        </div>
        <div class="reqLine">
          <p>Получатель</p>
          <p>ООО МКК «ФИНМОЛЛ» - Общество с ограниченной ответственностью Микрокредитная компания «ФИНМОЛЛ</p>
        </div>
        <div class="reqLine">
          <p>ИНН / КПП</p>
          <p>7705954143 / 785250001</p>
        </div>
        <div class="reqLine">
          <p>ОГРН</p>
          <p>1117746509638</p>
        </div>
        <div class="reqLine">
          <p>р/сч</p>
          <p>40701810738000002048 в ПАО Сбербанк</p>
        </div>
        <div class="reqLine">
          <p>БИК</p>
          <p>044525225</p>
        </div>
        <div class="reqLine">
          <p> к/сч</p>
          <p>30101810400000000225</p>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import CrossIcon from '@/assets/svg/cross';
export default {
  name: 'requisites-popup',
  components: { CrossIcon },
  methods: {
    closePopUp () {
      this.$store.commit('closePopUp');
    }
  }
};
</script>

<style scoped>
#popUpWin { height: calc(119.33vw - 10.67vw); display: flex; flex-direction: column; justify-content: space-between; z-index: 11}
#popUpWin>div {}
#popUpWin>div>.reqLines>.reqLine:first-child { border-top: 1px solid rgba(237, 237, 241, 1); border-bottom: 1px solid rgba(237, 237, 241, 1) }
#popUpWin>div>.reqLines>.reqLine { border-bottom: 1px solid rgba(237, 237, 241, 1); padding: 0.2vh 0 0.2vh 0; display: flex; justify-content: space-between }
#popUpWin>div>.reqLines>.reqLine>p { margin-right: 3vw }
#popUpWin>div>.reqLines>.reqLine>p:last-child { font-size: 3.73vw }
#popUpWin>div>h1 { margin-bottom: 4.27vw }
@media screen and (min-width: 760px) {}

@media screen and (min-width: 1200px) {
  #popUpWin { height: calc(461px - 40px); width: calc(600px - 40px) }
  #popUpWin>div {flex-direction: column}
  #popUpWin>div>h1 { margin-bottom: 20px }
  #popUpWin>div>.reqLines>.reqLine:first-child {}
  #popUpWin>div>.reqLines>.reqLine { padding: 0.2vh 0 0.2vh 0 }
  #popUpWin>div>.reqLines>.reqLine>p { margin-right: 0; width: 50%; font-size: 16px }
  #popUpWin>div>.reqLines>.reqLine>p:last-child { font-size: 16px }
}

</style>
